import styled from "styled-components";

export const ContainerFooter = styled.footer`
    padding: 10px;
    background-color: var(--light-blue-0);
    border: 1px solid var(--light-blue-3);
    border-radius: 8px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    & h5 {
        font-weight: 400;
        font-size: 14px;
        margin: 10px 0;
    }
    & ul{
        margin: 5px 0;
    }
    & li {
        font-size: 14px;
    }
    & a {
        text-decoration: none;
    }
`;
export const FooterTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 5px;
    margin-top: 8px;
    & span {
        display: grid;
        place-items: center;
    }
    & h3 {
        min-width: max-content;
        font-size: 14px;
        font-weight: 400;
        margin: 0;
        word-wrap: normal;
        word-break: normal;
    }
    &::after, &::before {
        display: block;
        content: "";
        width: 100%;
        border-top: 1px solid var(--light-blue-1);
    }
    &::after {
        margin-left: 5px;
    }
    &::before {
        margin-right: 5px;
    }
`;